import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import axios, { AxiosResponse } from "axios";
import { IFBCallSession, iFBCallLog } from "./fb-call-logs-model";

export class FBCallLogsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.FBCallLogs.configure(config);
  }

  FBCallLogs = Object.assign(
    new EntityServices<iFBCallLog>(SDKConfig, "fb-call-logs"),
    {
      initiateCall: async (data: {
        conversationId: string;
        messageId: string;
        sdpOffer: string;
      }) => {
        const results: AxiosResponse<any> = await axios.post(
          this.config.basePath + `/facebook/initiate-call`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      acceptCall: async (data: { callLogId: string; sdp: string }) => {
        const results: AxiosResponse<{
          status: boolean;
          session?: IFBCallSession;
        }> = await axios.post(
          this.config.basePath + `/facebook/accept-call`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      rejectCall: async (data: { callLogId: string }) => {
        const results: AxiosResponse<{ status: boolean }> = await axios.post(
          this.config.basePath + `/facebook/reject-call`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      terminateCall: async (data: { callLogId: string }) => {
        const results: AxiosResponse<{ status: boolean }> = await axios.post(
          this.config.basePath + `/facebook/terminate-call`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
